

export default class PrestadorLogin{
    RncoCedula:string =""
    Contrasena:string =""
}